<template>
    <button
        @click.prevent.stop="$emit('click', isFavorite)"
        data-like
        class="c-promos-like btn btn-icon"
        :class="{ 'is-active': isFavorite }"
    >
        <a-icon icon="Heart" />
    </button>
</template>

<script>
export default {
    name: 'PromotionPreviewHeart',
    props: {
        id: {
            type: Number,
            default: 0
        }
    },
    computed: {
        isFavorite() {
            return this.$store.getters.getFavoriteById(this.id)
        }
    }
}
</script>
